export const ROLES: { [key: string]: string } = {
  INSTRUCTOR: "INSTRUCTOR",
  MODERATOR: "MODERATOR",
  LEARNER: "LEARNER",
  GUEST: "GUEST"
};


export const GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/auth';